import isNewReduxUtil from 'modules/redux/utils/is-new'
import { delReduxService } from 'modules/redux/services'
import REDUX_ACTION from 'modules/redux/constants/action'
import { getRequiredRemotePropertiesModelUtil } from 'models/utils/get-required-remote-properties'
import getEndpointFromClassNameModelUtil from 'models/utils/get-endpoint-from-class-name'
import { getObjectUtil } from 'packages/src'

function deleting (path) {
  return {
    type: REDUX_ACTION.DELETE,
    payload: {
      path
    }
  }
}

function deleteSuccess (path, domainListPath) {
  return {
    type: REDUX_ACTION.DELETE_SUCCESS,
    payload: {
      path,
      domainListPath
    }
  }
}

function deleteError (path, error) {
  return {
    type: REDUX_ACTION.DELETE_ERROR,
    payload: {
      path,
      error
    }
  }
}

/**
 * Deletes the `Instance` at the given `path`.
 * @param  {string} path
 * @param  {string} [endpoint]
 * @param  {string} [domainListPath]
 * @param  {string} [additionalData]
 * @returns {Function}
 */
function deleteLegacyReduxAction ({
  path,
  endpoint,
  domainListPath,
  additionalData
}) {
  return (dispatch, getState) => {
    // Get the required data to delete the `Instance`
    const instance = getObjectUtil(getState(), path)
    if (!instance) {
      return
    }
    let { data } = instance
    data = getRequiredRemotePropertiesModelUtil(data)
    // Add additional data if necessary
    if (additionalData) {
      data = {
        ...data,
        ...additionalData
      }
    }
    // If the instance is new, delete the instance locally
    if (isNewReduxUtil(instance)) {
      dispatch(
        deleteSuccess(path, domainListPath)
      )
      return
    }
    dispatch(
      deleting(path)
    )
    // Get the `Instance`'s endpoint
    endpoint = endpoint || getEndpointFromClassNameModelUtil(data.className)
    // Delete the `Instance` remotely
    return delReduxService(endpoint, data)
      .then(() => {
        dispatch(
          deleteSuccess(path, domainListPath)
        )
      })
      .catch(error => {
        dispatch(
          deleteError(path, error)
        )
      })
  }
}

export {
  deleteLegacyReduxAction
}
